'use strict';
module.exports = require('./SelectButton.vue');